import { faSearch } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Input } from "antd";
import { memo, useCallback } from "react";

type Props = {
  placeholder?: string;
  value?: string;
  className?: string;
  suffix?: React.ReactNode;
  onChange?: (value: string) => void;
  onSearch?: (value: string) => void;
  onBlur?: (value: string) => void;
};

function AppSearch({
  placeholder,
  value,
  className,
  suffix,
  onChange,
  onSearch,
  onBlur,
}: Props) {
  const handleChange = useCallback(
    (evt: React.ChangeEvent<HTMLInputElement>) =>
      onChange?.(evt.currentTarget.value),
    [onChange]
  );
  const handleSearch = useCallback(
    (evt: React.KeyboardEvent<HTMLInputElement>) =>
      onSearch?.(evt.currentTarget.value),
    [onSearch]
  );
  const handleBlur = useCallback(
    (evt: React.FocusEvent<HTMLInputElement>) =>
      onBlur?.(evt.currentTarget.value),
    [onBlur]
  );

  return (
    <Input
      className={className}
      value={value}
      placeholder={placeholder || "Cerca..."}
      allowClear
      onChange={handleChange}
      onPressEnter={handleSearch}
      onBlur={handleBlur}
      prefix={<FontAwesomeIcon icon={faSearch} />}
      suffix={suffix}
    />
  );
}

export default memo(AppSearch);
